import React from 'react'

function Footer() {
    return (
        <div>
            <div className="container">
                <div className="footer">
                    <p className="pull-left">
                        Copyright &copy; 2017 | Mediumish
                    </p>
                    <p className="pull-right">
                        Mediumish by <a target="_blank" href="https://www.saifullah.co">Saifullah Siddique</a>
                    </p>
                    <div className="clearfix">
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
